<template>
  <div class="bg-[#23242A] text-white app-header p-4 custom">
    <div class="custom-full custom-left">
      <div class="">
        <div
          class="flex justify-between shadow-xl box-border items-center text-white h-[76px] rounded p-4 bg-[#2B2C32] mb-4"
        >
          <h2 class="font-bold text-2xl leading-[30px] tracking-[0.05px]">
            Inventory Snapshot Report
          </h2>
          <div class="flex flex-row gap-6">
            <buttton @click="exportFile"
              class="h-[44px] py-2 px-4 cursor-pointer flex justify-center hover:opacity-60 items-center bg-white rounded-md font-medium text-sm leading-[17.5px] tracking-[1.2px] text-[#2BA66B]"
              >Export</buttton
            >
            <button
              @click="submit"
              class="h-[44px] py-2 px-4 cursor-pointer bg-white flex justify-center hover:opacity-60 items-center rounded-md font-medium text-sm leading-[17.5px] tracking-[1.2px] text-[#2BA66B]"
            >
              RUN REPORT
            </button>
          </div>
        </div>
        <div
          class="flex flex-col justify-start shadow-xl box-border text-white h-full rounded p-4 bg-[#2B2C32] mb-2"
        >
        <h3
              class="font-bold text-base leading-5 mb-[18px] tracking-[0.15px]"
            >
              Select a type:
            </h3>
            <div
              class="flex items-center gap-[18px] border-b border-[#464851] pb-4"
            >
              <div class="flex items-center">
                <input
                  :checked="true"
                  value="product"
                  id="byProduct"
                  @click="selectType(false)"
                  type="radio"
                  name="selectType"
                  class="w-4 h-4 bg-transparent border-2 border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
                />
                <label
                  for="byProduct"
                  class="ml-2 text-base leading-5 font-normal tracking-wider text-white dark:text-gray-300"
                  >By product</label
                >
              </div>
              <div class="flex items-center">
                <input
                  id="byLocation"
                  value="location"
                  @click="selectType(true)"
                  type="radio"
                  name="selectType"
                  class="w-4 h-4 bg-transparent border-2 border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
                />
                <label
                  for="byLocation"
                  class="ml-2 text-base leading-5 font-normal tracking-wider text-white dark:text-gray-300"
                  >By lot</label
                >
              </div>
            </div>

          <div class="flex xl:items-end xl:flex-row flex-col gap-4 mb-3">
            <div class="xl:w-1/5 w-full">
              <div class="flex flex-col re-date" :class="'input-wrapper ' + (filter.date.error_type)">
                <label class="mb-0 text-xs">Date *</label>
                <div class="relative justify-center align-center input-clear ">
                  <svg
                    width="16"
                    class="absolute z-[99] left-[10px] bottom-[12px]"
                    height="18"
                    viewBox="0 0 16 18"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M8 10.6667C7.76389 10.6667 7.56597 10.5869 7.40625 10.4272C7.24653 10.2674 7.16667 10.0695 7.16667 9.83342C7.16667 9.5973 7.24653 9.39939 7.40625 9.23967C7.56597 9.07994 7.76389 9.00008 8 9.00008C8.23611 9.00008 8.43403 9.07994 8.59375 9.23967C8.75347 9.39939 8.83333 9.5973 8.83333 9.83342C8.83333 10.0695 8.75347 10.2674 8.59375 10.4272C8.43403 10.5869 8.23611 10.6667 8 10.6667ZM4.66667 10.6667C4.43056 10.6667 4.23264 10.5869 4.07292 10.4272C3.91319 10.2674 3.83333 10.0695 3.83333 9.83342C3.83333 9.5973 3.91319 9.39939 4.07292 9.23967C4.23264 9.07994 4.43056 9.00008 4.66667 9.00008C4.90278 9.00008 5.10069 9.07994 5.26042 9.23967C5.42014 9.39939 5.5 9.5973 5.5 9.83342C5.5 10.0695 5.42014 10.2674 5.26042 10.4272C5.10069 10.5869 4.90278 10.6667 4.66667 10.6667ZM11.3333 10.6667C11.0972 10.6667 10.8993 10.5869 10.7396 10.4272C10.5799 10.2674 10.5 10.0695 10.5 9.83342C10.5 9.5973 10.5799 9.39939 10.7396 9.23967C10.8993 9.07994 11.0972 9.00008 11.3333 9.00008C11.5694 9.00008 11.7674 9.07994 11.9271 9.23967C12.0868 9.39939 12.1667 9.5973 12.1667 9.83342C12.1667 10.0695 12.0868 10.2674 11.9271 10.4272C11.7674 10.5869 11.5694 10.6667 11.3333 10.6667ZM8 14.0001C7.76389 14.0001 7.56597 13.9202 7.40625 13.7605C7.24653 13.6008 7.16667 13.4029 7.16667 13.1667C7.16667 12.9306 7.24653 12.7327 7.40625 12.573C7.56597 12.4133 7.76389 12.3334 8 12.3334C8.23611 12.3334 8.43403 12.4133 8.59375 12.573C8.75347 12.7327 8.83333 12.9306 8.83333 13.1667C8.83333 13.4029 8.75347 13.6008 8.59375 13.7605C8.43403 13.9202 8.23611 14.0001 8 14.0001ZM4.66667 14.0001C4.43056 14.0001 4.23264 13.9202 4.07292 13.7605C3.91319 13.6008 3.83333 13.4029 3.83333 13.1667C3.83333 12.9306 3.91319 12.7327 4.07292 12.573C4.23264 12.4133 4.43056 12.3334 4.66667 12.3334C4.90278 12.3334 5.10069 12.4133 5.26042 12.573C5.42014 12.7327 5.5 12.9306 5.5 13.1667C5.5 13.4029 5.42014 13.6008 5.26042 13.7605C5.10069 13.9202 4.90278 14.0001 4.66667 14.0001ZM11.3333 14.0001C11.0972 14.0001 10.8993 13.9202 10.7396 13.7605C10.5799 13.6008 10.5 13.4029 10.5 13.1667C10.5 12.9306 10.5799 12.7327 10.7396 12.573C10.8993 12.4133 11.0972 12.3334 11.3333 12.3334C11.5694 12.3334 11.7674 12.4133 11.9271 12.573C12.0868 12.7327 12.1667 12.9306 12.1667 13.1667C12.1667 13.4029 12.0868 13.6008 11.9271 13.7605C11.7674 13.9202 11.5694 14.0001 11.3333 14.0001ZM1.75 17.3334C1.41667 17.3334 1.125 17.2084 0.875 16.9584C0.625 16.7084 0.5 16.4167 0.5 16.0834V3.16675C0.5 2.83341 0.625 2.54175 0.875 2.29175C1.125 2.04175 1.41667 1.91675 1.75 1.91675H3.10417V0.666748H4.45833V1.91675H11.5417V0.666748H12.8958V1.91675H14.25C14.5833 1.91675 14.875 2.04175 15.125 2.29175C15.375 2.54175 15.5 2.83341 15.5 3.16675V16.0834C15.5 16.4167 15.375 16.7084 15.125 16.9584C14.875 17.2084 14.5833 17.3334 14.25 17.3334H1.75ZM1.75 16.0834H14.25V7.12508H1.75V16.0834ZM1.75 5.87508H14.25V3.16675H1.75V5.87508ZM1.75 5.87508V3.16675V5.87508Z"
                      fill="white"
                    />
                  </svg>
                  
                  <Datepicker
                    inputFormat="yyyy-MM-dd"
                    :clearable="true"
                    v-model="filter.date.value"
                    :class="filter.date?'text-[#fff]':'text-[#9E9E9E]'"
                    class="h-[40px] rounded-md bg-gray-black w-full border-none text-base leading-5 pl-[34px]"
                    placeholder="Select a Date"
                  />
                </div>
                <p class="field-error label-text mt-1" v-if="filter.date.error_message" v-text="filter.date.error_message"></p>
                <p v-else>&nbsp;</p>
              </div>
            </div>            

            <div class="xl:w-1/5 w-full">
              <div :class="'input-wrapper relative ' + (filter.locationIds.error_type)">
                <label class="mb-0 text-xs">Locations*</label>
                <SelectLocation
                  class="bg-gray-black rounded relative"
                  v-model="filter.locationIds.value"
                  :options="vg_locations"
                  placeholder="Select all that apply"
                />
                <p class="field-error label-text mt-1" v-if="filter.locationIds.error_message" v-text="filter.locationIds.error_message"></p>
                <p v-else>&nbsp;</p>
              </div>
            </div>

            <div class="xl:w-1/5 w-full">
              <div :class="'input-wrapper relative ' + (filter.categoryIds.error_type)">
                <label class="mb-0 text-xs">Category</label>
                <SelectCheckbox v-model="filter.categoryIds.value" :options="categories" placeholder="Select" class="relative  w-full h-[40px] rounded bg-gray-black focus:border-0 focus:ring-0 border-0" :class="filter.categoryIds.value.length>0?'text-white':'text-theme-878686'" />
                <p class="field-error label-text mt-1" v-if="filter.locationIds.error_message" v-text="filter.locationIds.error_message"></p>
                <p v-else>&nbsp;</p>
              </div>
            </div>

            <div class="xl:w-2/5 w-full">
              <div :class="'input-wrapper flex flex-col ' + (filter.productIds.error_type)">
                <div class="flex flex-row gap-3 items-end">
                  <div class="w-full">
                    <label class="mb-0 text-xs">Products</label>
                    <label for="select"
                      class="h-[40px] flex justify-start items-center rounded-md bg-gray-black w-full border-none text-base leading-5 p-2"
                    >
                      <div :class="filter.productIds.value.length>0?'text-[#fff]':'text-[#9E9E9E]'">{{filter.productIds.value.length>0?`${filter.productIds.value.length} Selected`:'Select all that apply'}}</div>
                    </label>
                  </div>
                  <button id="select" @click="openCategoryProductModal()"
                    class="h-[40px] w-[92px] cursor-pointer hover:opacity-50 uppercase rounded-md py-2 px-4 border border-[#2BA66B] font-medium text-sm leading-[17.5px] tracking-[2px] text-[#2BA66B]"
                  >
                    Select
                  </button>
                </div>
                <p class="field-error label-text mt-1" v-if="filter.productIds.error_message" v-text="filter.productIds.error_message"></p>
                <p v-else>&nbsp;</p>
              </div>
            </div>

            <div class="">
              <span class="text-xs">In-Stock Only</span>
              <label
                class="flex items-center cursor-pointer w-[100px] h-[40px]"
              >
                <input
                  v-model="filter.toggle.value"
                  type="checkbox"
                  class="hidden peer"
                />
                <div
                  class="relative toggle-bg new-toggle  border-2  h-8 w-[52px] rounded-full"
                  :class="filter.toggle.value?'bg-theme-green border-theme-green':'bg-theme-red border-theme-red'"
                ></div>
                <span
                  class="ml-2 text-sm font-medium uppercase text-theme-white"
                  >{{filter.toggle.value?'ON':'OFF'}}</span
                >
              </label>
              <p>&nbsp;</p>
            </div>
          </div>

          <h5 class="font-normal text-xs leading-5 mb-3 tracking-[0.15px]">
            Export File Format
          </h5>
          <div class="flex items-center gap-[18px] pb-4">
            <!-- <div class="flex items-center">
              <input
                @click="selectFormat('sheet')"
                id="sheet"
                value="sheet"
                type="radio"
                name="no_reward"
                class="w-4 h-4 bg-transparent border-2 border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
              />
              <label
                for="sheet"
                class="ml-2 text-base leading-5 font-normal tracking-wider text-white dark:text-gray-300"
                >Google Sheet</label
              >
            </div> -->
            <div class="flex items-center">
              <input
                checked
                @click="selectFormat('csv')"
                id="format"
                value="csv"
                type="radio"
                name="no_reward"
                class="w-4 h-4 bg-transparent border-2 border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
              />
              <label
                for="format"
                class="ml-2 text-base leading-5 font-normal tracking-wider text-white dark:text-gray-300"
                >XLSX</label
              >
            </div>
          </div>
        </div>
        <List
          v-if="payload && payload.length > 0"
          :payload="payload"
          :sumPayload="sumPayload"
          :includeLot="filter.includeLot.value"
          :filter="filter"
        />
        <div class="text-theme-red" v-else-if="loaded">
          No Data Found.
        </div>
        <CategoryWithProductModal v-if="categoryProductPop" :existingproducts="filter.productIds.value"  :closeClick="closeCategoryWithProductModal" :actionClick="setCategoriesWithProduct"/>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent, ref } from 'vue'
import Datepicker from 'vue3-datepicker'
import SelectLocation from '@/components/form/SelectLocations'
import { mapGetters, mapMutations } from 'vuex'
import { useSnackbar } from "vue3-snackbar"
import CategoryWithProductModal from '@/components/CategoriesWithProductModal.vue';
import Helpers from '@/helpers';
import StringHelpers from '@/helpers/string';
import ReportHelpers from '@/helpers/report'
import ReportApis from '@/controllers/ReportApis'
import moment from 'moment'
import writeXlsxFile from 'write-excel-file';
import ProductApi from '@/controllers/BusinessProductApis'
import SelectCheckbox from '@/components/form/SelectCheckbox.vue'
import List from './List'

export default defineComponent({
  components: {
    List,
    Datepicker,
    SelectLocation,
    SelectCheckbox,
    CategoryWithProductModal
  },
  setup() {
    const snackbar = useSnackbar();
    const filter = ref({
      includeLot: {
        value: false,
        error_type: '',
        error_message: '',
        validations: ['required'],
      },
      date: {
        value: null,
        error_type: '',
        error_message: '',
        validations: ['required'],
      },
      productIds: {
        value: [],
        error_type: '',
        error_message: '',
        validations: [],
      },
      locationIds: {
        value: [],
        error_type: '',
        error_message: '',
        validations: ['required'],
      },
      categoryIds: {
        value: [],
        error_type: '',
        error_message: '',
        validations: [''],
      },
      toggle: {
        value: false,
        error_type: '',
        error_message: '',
        validations: [],
      },
      type: {
        value: 'csv',
        error_type: '',
        error_message: '',
        validations: [],
      }
    })
    const categories = ref([])
    const categoryProductPop = ref(false)
    const downloadableCsv = ref([])
    const payload = ref([])
    const sumPayload = ref({})
    const loaded = ref(false)

    return {
      snackbar,
      filter,
      categories,
      categoryProductPop,
      downloadableCsv,
      payload,
      sumPayload,
      loaded
    }
  },
  mounted(){
    this.getCategory()
  },
  watch: {
    'filter.includeLot.value'() {
      this.payload = []
      this.sumPayload = {}
      this.loaded = false
    }
  },
  computed: {
    ...mapGetters({
      vg_locations: 'location/list',
      vg_selectedLocation: 'location/selected'
    })
  },
  methods: {
    selectType(val) {
      this.filter.includeLot.value = val
    },
    selectFormat(type) {
      this.filter.type.value = type
    },
    openCategoryProductModal(){
      this.categoryProductPop = true;
    },
    closeCategoryWithProductModal() {
      this.categoryProductPop = false;
    },
    /**
     * Get data selected from category modal
     */
    setCategoriesWithProduct(data) {
      this.filter.productIds.value = data.pids;
      this.closeCategoryWithProductModal();
    },
    async validateFields(fields) {
        let res = await Helpers.validateFormFields(this.filter, fields);
        // capture the fields
        this.form = res.data;
        return res.error ? false : true;
    },
    async submit() {
      this.loaded = false
      this.payload = []
      let validate = await this.validateFields(['date', 'productIds', 'locationIds']);
      if(!validate) {
          return ;
      }
      let data = {
        locationIds: this.filter.locationIds.value,
        date: moment(this.filter.date.value).format('YYYY-MM-DD'),
        inStock: this.filter.toggle.value,
        includeLot: this.filter.includeLot.value
      }
      data.productIds = this.filter.productIds.value
      data.categoryIds = this.filter.categoryIds.value
      this.vm_spinner(true)
      let res = await ReportApis.inventorySnapshotReport(data)
      let payload = await this.concatBatches(res?.data?.payload)
      this.loaded = true
      this.vm_spinner(false)
      if(res.status == 200){
        let tempRows = payload
        let totalRow = {}
        let product = {name: '', variantName: ''}
        // sum the all rows
        for(let i=0; i<payload.length; i++){
          tempRows[i] = {...tempRows[i], ...tempRows[i].productPricing}
          // take stock, total accordingly before sum
          tempRows[i]['stock'] = this.isCurrentDate(this.filter.date.value)?tempRows[i].productPricing?.stock:tempRows[i].inventorySnapshots?.[0]?.closingInventory || 0
          tempRows[i]['batchStock'] = this.isCurrentDate(this.filter.date.value) ? tempRows[i].batchUploadDetails?.[0]?.current_nou : tempRows[i].batchUploadDetails[0]?.inventory_snapshot_batches?.[0]?.closing_inventory || 0
          tempRows[i]['totalStockCost'] = tempRows[i].productPricing?.totalStockCost ? tempRows[i].productPricing.totalStockCost : (tempRows[i].inventorySnapshots?.[0]?.totalStockCost ? tempRows[i].inventorySnapshots[0].totalStockCost:0)
          tempRows[i]['sale_price'] = tempRows[i].productPricing?.sale_price ? tempRows[i].productPricing?.sale_price : ((tempRows[i].inventorySnapshots?.[0]?.sale_price)?tempRows[i].inventorySnapshots[0].sale_price:0)
          tempRows[i]['profitMargin'] = tempRows[i].productPricing?.profitMargin ? tempRows[i].productPricing.profitMargin : ((tempRows[i].inventorySnapshots?.[0]?.profitMargin)?tempRows[i].inventorySnapshots[0].profitMargin:null)
          tempRows[i]['profit_margin_percentage'] = tempRows[i].productPricing?.profit_margin_percentage ? tempRows[i].productPricing?.profit_margin_percentage : ((tempRows[i].inventorySnapshots?.[0]?.profit_margin_percentage)?tempRows[i].inventorySnapshots[0].profit_margin_percentage:null)
          tempRows[i]['markup'] = tempRows[i].productPricing?.markup ? tempRows[i].productPricing?.markup : ((tempRows[i].inventorySnapshots?.[0]?.markup)?tempRows[i].inventorySnapshots[0].markup:null)
          tempRows[i]['averageCost'] = tempRows[i].batchUploadDetails[0]?.averageCost ? tempRows[i].batchUploadDetails[0].averageCost : ((tempRows[i].batchUploadDetails?.[0]?.inventory_snapshot_batches?.[0]?.averageCost)?tempRows[i].batchUploadDetails[0].inventory_snapshot_batches[0].averageCost:0)

          // batchTotalCost
          if(this.isCurrentDate(this.filter.date.value)){
            tempRows[i]['batchTotalCost'] = (tempRows[i].batchUploadDetails?.[0]?.cost * tempRows[i].batchUploadDetails?.[0]?.current_nou) || 0
          }else{
            if(tempRows[i].batchUploadDetails?.[0]?.inventory_snapshot_batches?.[0]?.closing_inventory && tempRows[i].batchUploadDetails?.[0]?.inventory_snapshot_batches?.[0]?.cost){
              tempRows[i]['batchTotalCost'] = tempRows[i].batchUploadDetails[0].inventory_snapshot_batches[0].closing_inventory*tempRows[i].batchUploadDetails?.[0]?.inventory_snapshot_batches?.[0]?.cost
            }else{
              tempRows[i]['batchTotalCost'] = 0
            }
          }
          this.SumEachColumn(tempRows[i], totalRow, payload.length, product)
          product = tempRows[i]
        }
        // roundoff
        totalRow['profit_margin_percentage'] = StringHelpers.roundOff(totalRow['profit_margin_percentage'])
        totalRow['markup'] = StringHelpers.roundOff(totalRow['markup'])
        this.sumPayload = totalRow
        this.payload = tempRows
        return res
      }else{
        this.payload = []
        return null
      }
    },
    SumEachColumn(row, totalRow, totalCount, product){
      let columns = ['batchStock', 'batchTotalCost']
      for(let col in row){
        if(columns.includes(col)){
          totalRow[col] = +((totalRow[col]?parseFloat(totalRow[col]):0)+(row[col]?parseFloat(row[col]):0)).toFixed(2)
        }else if(col === 'stock'){
          // sum of unique product and variant. In lot report, we need to sum the stock for each product and variant. variant will be same accross multiple lots
          if(product.name !== row.name || product.variantName !== row.variantName){
            totalRow[col] = +((totalRow['stock']?parseFloat(totalRow['stock']):0)+(row['stock']?parseFloat(row['stock']):0)).toFixed(2)
          }
        }else if(col==='sale_price'){
          if(product.name !== row.name || product.variantName !== row.variantName){
            totalRow[col] = +((totalRow[col]?parseFloat(totalRow[col]):0)+((row['stock']?row['stock']:0)*(row[col]?parseFloat(row[col]):0))).toFixed(2)
          }
        }else if(col==='profitMargin'){
          if(product.name !== row.name || product.variantName !== row.variantName){
            totalRow[col] = +((totalRow[col]?parseFloat(totalRow[col]):0)+((row['stock']?row['stock']:0)*(row[col]?parseFloat(row[col]):0))).toFixed(2)
          }
        }else if(col==='profit_margin_percentage'){
          totalRow[col] = +((totalRow[col]?parseFloat(totalRow[col]):0)+((row[col]?parseFloat(row[col]):0)/totalCount))
        }else if(col==='markup'){
          totalRow[col] = +((totalRow[col]?parseFloat(totalRow[col]):0)+((row[col]?parseFloat(row[col]):0)/totalCount))
        }else{
          totalRow[col] = ''
        }
      }
    },
    async exportFile(){
      let res = await this.submit()
      if(res){
        let payloadWithTotal = null
        if(this.payload.length>1){
          payloadWithTotal = [this.sumPayload, ...this.payload]
        }else{
          payloadWithTotal = this.payload
        }
        this.createXlSheet(payloadWithTotal)
      }else{
        this.snackbar.add({
              type: 'info',
              text: 'Data not found!',
              duration: 3000,
          })
      }
    },

    async getCategory(){
            let res = await ProductApi.fetchAllCategory()
            if(res.data?.payload?.category){
                for(let i=0; i<res.data.payload.category.length; i++){
                    this.categories.push(res.data.payload.category[i])
                    if(res.data.payload.category[i].subCategories && res.data.payload.category[i].subCategories.length>0){
                        for(let j=0; j<res.data.payload.category[i].subCategories.length; j++){
                            this.categories.push(res.data.payload.category[i].subCategories[j])
                        }
                    }
                }
            }
        },

    async concatBatches(payload){
      let total = []
      if(payload?.length && payload?.length>0){
        for(let i=0; i<payload.length; i++){
          if(payload[i].batchUploadDetails?.length>0){
            for(let j=0; j<payload[i].batchUploadDetails.length; j++){
              let obj = {...payload[i]}
              obj.categoryName = (payload[i].category && payload[i].category.parent)? payload[i].category.parentCategory.name : payload[i].category?.name
              obj.subCategoryName = (payload[i].category && payload[i].category.parentCategory) ? payload[i].category?.name : ''
              obj.batchUploadDetails = [payload[i].batchUploadDetails[j]]
              total.push(obj)
            }
          }else{
            let obj = {...payload[i]}
            obj.categoryName = (payload[i].category && payload[i].category.parent)? payload[i].category.parentCategory.name : payload[i].category?.name
            obj.subCategoryName = (payload[i].category && payload[i].category.parentCategory) ? payload[i].category?.name : ''
            obj.batchUploadDetails = [{
              batch_lot: '--',
              cost: null,
              current_nou: 0,
              inventory_snapshot_batches: [],
              packaged_on: null
            }]
            total.push(obj)
          }
        }
      }
      return total
    },

    async createXlSheet(jsonData) {
      try {
        let schema = [
          {
            column: 'Location Name',
            type: String,
            wrap: false,
            alignVertical: 'center',
            align: 'center',
            value: (i) => {
              if(i.productPricing?.locations?.name) {
                return i.productPricing.locations.name;
              }else if(i.inventorySnapshots?.[0]?.location?.name){
                return i.inventorySnapshots[0].location.name;
              }else{
                ''
              }
            }, 
          },
          {
            column: 'Product Name',
            type: String,
            wrap: false,
            alignVertical: 'center',
            align: 'center',
            value: i => i.name ? i.name :''
          },
          {
            column: 'Product variant name',
            type: String,
            wrap: false,
            alignVertical: 'center',
            align: 'center',
            value: i => {
              if(i.variantName){
                return i.variantName;
              } else {
                return '';
              }
            }
          },
          {
            column: 'Brand',
            type: String,
            wrap: false,
            alignVertical: 'center',
            align: 'center',
            value: i => {
              if(i.brand && i.brand.name){
                return i.brand.name;
              } else {
                return '';
              }
            }
          }
        ];

        if(this.filter.includeLot.value){
          schema.push({
            column: 'Product Lot',
            type: String,
            wrap: false,
            alignVertical: 'center',
            align: 'center',
            value: i => (i.batchUploadDetails?.[0]?.batch_lot) ? i.batchUploadDetails[0]?.batch_lot : '' 
          })
        }
        schema.push({
          column: 'Category',
          type: String,
          wrap: false,
          alignVertical: 'center',
          align: 'center',
          value: i => i.categoryName ? i.categoryName : '' 
        },
        {
          column: 'Sub Category',
          type: String,
          wrap: false,
          alignVertical: 'center',
          align: 'center',
          value: i => i.subCategoryName ? i.subCategoryName : '' 
        },
        {
          column: 'SKU',
          type: String,
          wrap: false,
          alignVertical: 'center',
          align: 'center',
          value: i => i.sku ? i.sku : '' 
        },
        {
          column: 'Compliance Type',
          type: String,
          wrap: false,
          alignVertical: 'center',
          align: 'center',
          value: i => i.complianceType ? i.complianceType : '' 
        },
        {
          column: 'Unit of measurement',
          type: String,
          wrap: false,
          alignVertical: 'center',
          align: 'center',
          value: i => i.concentration_unit ? i.concentration_unit : '' 
        },
        {
          column: 'Stock',
          type: Number,
          wrap: false,
          alignVertical: 'center',
          align: 'center',
          value: i => i.stock ? Number(i.stock) : 0
        })
        if(this.filter.includeLot.value){
          schema.push({
            column: 'Batch Stock',
            type: Number,
            wrap: false,
            alignVertical: 'center',
            align: 'center',
            value: i => i.batchStock ? Number(i.batchStock) : 0
          },{
            column: 'Batch Total Cost',
            type: Number,
            wrap: false,
            alignVertical: 'center',
            align: 'center',
            value: i => i.batchTotalCost
          })
        }
        schema.push(
        {
          column: 'Total Cost In Stock',
          type: Number,
          wrap: false,
          alignVertical: 'center',
          align: 'center',
          value: i => i.totalStockCost
        })
        if(this.filter.includeLot.value){
          schema.push({
            column: 'Average Unit Cost in Stock',
            type: Number,
            wrap: false,
            alignVertical: 'center',
            align: 'center',
            value: i => i.averageCost
          })
        }else{
          schema.push({
            column: 'Average Unit Cost in Stock',
            type: Number,
            wrap: false,
            alignVertical: 'center',
            align: 'center',
            value: i => i.productPricing?.cost ? i.productPricing.cost : ((i.inventorySnapshots?.[0]?.cost)?i.inventorySnapshots[0].cost: "")
          })
        }
        schema.push({
          column: 'Retail Price',
          type: Number,
          wrap: false,
          alignVertical: 'center',
          align: 'center',
          value: i => i.sale_price ? Number(i.sale_price) : 0
        },
        {
          column: 'Profit Margin',
          type: Number,
          wrap: false,
          alignVertical: 'center',
          align: 'center',
          value: i => i.profitMargin ? Number(i.profitMargin) : 0
        },
        {
          column: 'Profit Margin Percentage',
          type: Number,
          wrap: false,
          alignVertical: 'center',
          align: 'center',
          value: i => i.profit_margin_percentage ? Number(i.profit_margin_percentage) : 0
        },
        {
          column: 'Markup',
          type: Number,
          wrap: false,
          alignVertical: 'center',
          align: 'center',
          value: i => i.markup ? Number(i.markup) : 0
        })
        if(this.filter.includeLot.value){
          schema.push({
            column: 'Lot Received On',
            type: String,
            wrap: false,
            alignVertical: 'center',
            align: 'center',
            value: i => (i.batchUploadDetails?.[0]?.createdAt) ? this.formatDate(i.batchUploadDetails[0].createdAt) : '' 
          })
        }else{
          schema.push({
            column: 'First Received On',
            type: String,
            wrap: false,
            alignVertical: 'center',
            align: 'center',
            value: i => (i.inventoryAdjustment?.createdAt) ? this.formatDate(i.inventoryAdjustment?.createdAt) : '' 
          })
        }
        schema.push({
          column: 'Created At',
          type: String,
          wrap: false,
          alignVertical: 'center',
          align: 'center',
          value: i => (i.inventorySnapshots?.[0]?.createdAt) ? this.formatDate(i.inventorySnapshots?.[0]?.createdAt) : '' 
        })

        let widthArr = await ReportHelpers.calculateWidth(schema)
        await ReportHelpers.addWidthToSchema(schema, widthArr)
        let xlBlob = await writeXlsxFile(jsonData, {
          schema: schema,
        });
        let fileName = `Inventory-Snapshot-${moment(this.filter.date.value).format('YYYY-MM-DD')}.xlsx`;
        let url = URL.createObjectURL(xlBlob);
        let link = document.createElement("a");
        link.setAttribute('href', url);
        link.setAttribute('download', fileName);
        link.style.visibility = 'hidden';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        let self = this
        setTimeout(function(){
          self.snackbar.add({
            type: 'info',
            text: 'File downloaded',
            duration: 3000,
          })
        }, 1000)

      } catch(err) {
        console.log(err)
        return this.snackbar.add({
          type: 'info',
          text: 'Something went wrong. Please try again later.',
          duration: 3000,
        })
      }
    },
    isCurrentDate(date){
      if(!date) return
      let defaultTimeZone = this.vg_selectedLocation.timezone?this.vg_selectedLocation.timezone:'America/Toronto';
      return moment(moment().tz(defaultTimeZone).format('YYYY-MM-DD')).isSame(date)
    },
    formatDate(date){
      if(!date) return ''
      let defaultTimeZone = this.vg_selectedLocation.timezone?this.vg_selectedLocation.timezone:'America/Toronto';
      return moment(date).tz(defaultTimeZone).format('YYYY-MM-DD hh:mm:ss A')
    },

    ...mapMutations({
      vm_spinner: 'spinner/mutateSpinner'
    })
  }
})
</script>